"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetToolCountAndSpend = void 0;
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var react_redux_1 = require("react-redux");
var other_1 = require("utils/selectors/other");
var useGetToolCountAndSpend = function () {
    var sStatsTeamData = (0, react_redux_1.useSelector)(other_1.selectServiceStatsTeamData);
    return function (cT) {
        var _a;
        var sStats = (_a = sStatsTeamData === null || sStatsTeamData === void 0 ? void 0 : sStatsTeamData.teamSStats) === null || _a === void 0 ? void 0 : _a[cT.id];
        if (!sStats)
            return { spend: 0, serviceStats: [] };
        return {
            spend: (0, sumBy_1.default)(sStats, function (sS) { return ((sS.calculatedAnnualSpend || 0) * (cT.headcount || 0)) / sStatsTeamData.totalHeadcounts[sS.id]; }),
            serviceStats: sStats,
        };
    };
};
exports.useGetToolCountAndSpend = useGetToolCountAndSpend;
